import { LinkButton, type LinkButtonProps, LinkType } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { type IconType } from "~/common/components/icon/IconType";
import { IconSize } from "~/common/components/icon/IconSize";
import { forwardRef } from "react";
import classNames from "classnames";
import { styled } from "~/common/mui";
import { C_ON_SURFACE_VARIANT, C_OUTLINE } from "~/common/components/icon/Colors";

interface Props extends Omit<LinkButtonProps, "children"> {
  icon: IconType;
  active?: boolean;
}

export const MobileNavButton = forwardRef<HTMLButtonElement, Props>(({ active, icon, className, ...rest }, ref) => {
  return (
    <StyledLinkButton
      className={classNames("scha__mobile-navigation__button", className)}
      variant={active ? LinkType.PRIMARY : LinkType.NAVIGATION}
      ref={ref}
      {...rest}
    >
      <Icon type={icon} size={IconSize.FONT_20} />
    </StyledLinkButton>
  );
});

const StyledLinkButton = styled(LinkButton)({
  marginRight: "8px",
  "&.scha__link--navigation": {
    color: C_ON_SURFACE_VARIANT,
  },
  ".scha-icon-list": {
    outline: `1px solid ${C_OUTLINE}`,
    outlineOffset: "8px",
    borderRadius: "50%",
  },
});
